<div class="layoutBlock">
    <div class="columnThreeQuarter">
        <p-panel header="{{'fs.res.common.projects' | hisUi}}">
            <div *ngIf="!projects?.length">
                {{'fs.res.common.project.noProject' | hisUi}}
            </div>
            <div *ngIf="projects && projects.length > 0">
                <p-table [value]="projects" [paginator]="false">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'fs.res.finance.project.Project.defaulttext' | hisUi}}</th>
                            <th>{{'fs.res.project.Project.projectHeads' | hisUi}}</th>
                            <th>{{'fs.res.finance.project.Project.startdate' | hisUi}}</th>
                            <th>{{'fs.res.finance.project.Project.enddate' | hisUi}}</th>
                            <th>{{'fs.res.finance.project.teamMembers' | hisUi}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-project>
                        <tr>
                            <td>{{project.defaulttext}}</td>
                            <td>
								<span *ngFor="let member of project.members">
									<span *ngIf="member.positionType.id === 1">
										{{member.surname}}, {{member.firstname}}<br/>
									</span>
								</span>
                            </td>
                            <td>{{ project.startdate | date: dateFormat }}</td>
                            <td>{{ project.enddate | date: dateFormat }}</td>
                            <td>
								<span *ngFor="let member of project.members">
									<span *ngIf="member.positionType.id >= 2">
										{{member.surname}}, {{member.firstname}}<br/>
									</span>
								</span>
                            </td>
                            <!-- <td>Förderkennzeichen?</td> -->
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-panel>
    </div>
</div>
